var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"header"}),_c('div',{staticClass:"main-menu"},[_c('div',{staticClass:"main-menu-link",attrs:{"data-to":"learning"},on:{"click":_vm.goTo}},[_vm._v(" Обучение ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }